import React, { memo } from "react";
import useStyles from "./styles";
import moment from "moment";

import { Grid } from "@material-ui/core";
import { Images } from "config/images";
import { formatCash } from "config/constant";

const RemainingPoints = props => {
	const classes = useStyles();
	const { loyaltyDetail } = props;

	return (
		<React.Fragment>
			<Grid classes={{ root: classes.root }}>
				<Grid container classes={{ root: classes.title }}>
					<Grid item xs={7}>
						Điểm còn lại
					</Grid>
					<Grid item xs={5} style={{ textAlign: "end" }}>
						(1) - (2) - (3)
					</Grid>
				</Grid>
				<Grid classes={{ root: classes.bgPoint }}>
					<Grid classes={{ root: classes.point }}>
						<img src={Images.icDollar} alt="icDollar" />{" "}
						{formatCash(loyaltyDetail?.pointDetail?.point || 0)}{" "}
						điểm
					</Grid>
				</Grid>
			</Grid>
			<Grid classes={{ root: classes.root }}>
				<Grid container style={{ marginBottom: 10 }}>
					<Grid item xs={4}>
						<Grid classes={{ root: classes.titleNumber }}>(1)</Grid>
						<Grid classes={{ root: classes.text }}>
							Tổng điểm <br /> đã duyệt
						</Grid>
						<Grid style={{ padding: "5px 10px" }}>
							<Grid classes={{ root: classes.inputPoint }}>
								{formatCash(
									loyaltyDetail?.pointDetail?.totalPoint || 0
								)}
							</Grid>
						</Grid>
					</Grid>
					<Grid item xs={4} classes={{ root: classes.border }}>
						<Grid classes={{ root: classes.titleNumber }}>(2)</Grid>
						<Grid classes={{ root: classes.text }}>
							Điểm đã dùng
						</Grid>
						<Grid style={{ padding: "5px 10px" }}>
							<Grid classes={{ root: classes.inputPoint }}>
								{formatCash(
									loyaltyDetail?.pointDetail
										?.totalPointUsed || 0
								)}
							</Grid>
						</Grid>
					</Grid>
					<Grid item xs={4}>
						<Grid classes={{ root: classes.titleNumber }}>(3)</Grid>
						<Grid classes={{ root: classes.text }}>
							Điểm đang
							<br /> đổi quà
						</Grid>
						<Grid style={{ padding: "5px 10px" }}>
							<Grid classes={{ root: classes.inputPoint }}>
								{formatCash(
									loyaltyDetail?.pointDetail?.pointPurchase ||
										0
								)}
							</Grid>
						</Grid>
					</Grid>
				</Grid>
				<Grid classes={{ root: classes.titleNote }}>
					Điểm tích lũy sẽ đến hết ngày{" "}
					{loyaltyDetail?.pointExpirationDate}
				</Grid>
			</Grid>
			<Grid classes={{ root: classes.root }}>
				<Grid container style={{ marginBottom: 10 }}>
					<Grid
						item
						xs={8}
						classes={{ root: classes.temporaryPurchasePoint }}
					>
						Điểm mua hàng tạm tính
					</Grid>
					<Grid item xs={4}>
						<Grid classes={{ root: classes.inputPoint }}>
							{formatCash(
								loyaltyDetail?.pointDetail?.pointRedeem || 0
							)}
						</Grid>
					</Grid>
				</Grid>
				<Grid classes={{ root: classes.titleNote }}>
					({moment().startOf("month").format("DD/MM/YYYY")} -{" "}
					{moment().format("DD/MM/YYYY")})
				</Grid>
			</Grid>
		</React.Fragment>
	);
};

export default memo(RemainingPoints);
